import { useEffect, useRef } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSnapshot } from 'valtio';
import { toast } from 'react-toastify';
import { authStore } from '../../../store/authStore';
import { roleActions, roleStore, Role } from '../../../store/roleStore';

export function AdminRouteGuard() {
  const { isAuthenticated, user } = useSnapshot(authStore);
  const location = useLocation();
  const deniedToastShown = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || !user?.isAdmin) {
      return;
    }
    // Enter admin mode when landing on /admin/* (e.g. deep link). Do not depend on
    // `role` here — exiting admin while still on an admin URL would re-enter instantly.
    if (roleStore.role === Role.ADMIN) {
      return;
    }
    roleActions.enterAdminMode();
  }, [isAuthenticated, user?.isAdmin, location.pathname]);

  if (!isAuthenticated) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (!user?.isAdmin) {
    if (!deniedToastShown.current) {
      deniedToastShown.current = true;
      toast.error('You do not have permission to access this page');
    }
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
